import { render, staticRenderFns } from "./FranchiseView.vue?vue&type=template&id=d870794e&"
import script from "./FranchiseView.vue?vue&type=script&lang=js&"
export * from "./FranchiseView.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports